<template>
  <v-card v-if="user" flat>
    <v-card-title heading-1>{{ lang.subscriptions }}</v-card-title>
    <v-card-subtitle
      v-if="
        user.billing_account_subs && user.billing_account_subs.activeSubs > 0
      "
    >
      <span class="mr-1">{{ lang.licenses }}:</span>
      {{ user.billing_account_subs.activeSubs }}
    </v-card-subtitle>
    <v-card-text style="overflow-y: scroll;height:calc(100vh - 150px)">
      <v-layout
        row
        wrap
        v-if="checkActiveSubs()"
        transition="slide-x-transition"
      >
        <v-flex xs12 pa-2>
          <v-card
            class="ma-1"
            v-for="sub in user.billing_account_subs.subs"
            v-bind:key="sub.id"
          >
            <v-card-title>{{
              sub.metadata.name || sub.created | moment("MMMM DD, YYYY")
            }}</v-card-title>
            <v-card-text>
              <v-layout row wrap pa-3>
                <v-flex xs12>
                  <span class="subtitle-1 font-weight-bold mr-1"
                    >{{ lang.coupon_id }}:</span
                  >
                  <span class="subtitle-1">{{
                    sub.metadata.coupon || "N/A"
                  }}</span>
                </v-flex>
                <v-flex xs12>
                  <span class="subtitle-1 font-weight-bold mr-1"
                    >{{ lang.start }}:</span
                  >
                  <span class="subtitle-1">{{
                    sub.current_period_start | moment("MMMM DD, YYYY")
                  }}</span>
                </v-flex>
                <v-flex xs12>
                  <span class="subtitle-1 font-weight-bold mr-1"
                    >{{ lang.end }}:</span
                  >
                  <span class="subtitle-1">{{
                    sub.current_period_end | moment("MMMM DD, YYYY")
                  }}</span>
                </v-flex>
                <!-- <v-flex xs12>
                  <span class="subtitle-1 font-weight-bold mr-1">{{lang.autorenew}}:</span>
                  <span class="subtitle-1">{{sub.cancel_at_period_end? lang.no:lang.yes}}</span>
                </v-flex> -->
                <v-flex xs12>
                  <span class="subtitle-1 font-weight-bold mr-1"
                    >{{ lang.subscription_amount }}:</span
                  >
                  <span class="subtitle-1"
                    >{{ getData(sub).total || 0 }}
                    {{ getCurrency(sub.plan.currency) }}:</span
                  >
                </v-flex>
                <v-flex xs12>
                  <span class="subtitle-1 font-weight-bold mr-1"
                    >{{ lang.num_players }}:</span
                  >
                  <span class="subtitle-1">{{ getData(sub).quantity }}</span>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout v-else-if="loading"></v-layout>
      <v-layout v-else>
        <v-card flat>
          <v-card-text>{{ lang.no_subscriptions }}</v-card-text>
        </v-card>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
const utils = require("@/classes/utils/utils.js").Utils;
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["lang", "adminUser"]),
  },
  props: {
    user: {
      default: false,
    },
    loading: {
      default: false,
    },
  },
  methods: {
    getCurrency(currency) {
      switch (currency) {
        case "usd":
          return this.lang.dollars;
        case "aud":
          return this.lang.au_dollars;
      }
      return currency;
    },
    getData(sub) {
      if (!sub || !sub.items || !sub.items.data || sub.items.data.length == 0) {
        return {};
      }
      return {
        quantity: sub.items.data[0].quantity,
        total:
          (sub.items.data[0].plan.amount / 100) * sub.items.data[0].quantity,
      };
    },
    checkActiveSubs() {
      if (
        this.user.billing_account_subs != null &&
        this.user.billing_account_subs.activeSubs > 0
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
